import { render, staticRenderFns } from "./BrainGames.vue?vue&type=template&id=5ee894e0&scoped=true"
import script from "./BrainGames.vue?vue&type=script&lang=js"
export * from "./BrainGames.vue?vue&type=script&lang=js"
import style0 from "./BrainGames.vue?vue&type=style&index=0&id=5ee894e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee894e0",
  null
  
)

export default component.exports